import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import HeaderMenu from "./header-menu";
import KhatabaIcon from "./KhatabaIcon";
import UserName from "./UserName";
import getDashBoardStore from "../../stores/dashboard-store";
import Et3Text from "../../core/et3-text";
import i18n from "../../constants/i18n";

const Header = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const isAlert = getDashBoardStore().getIsAlert.get();

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100
      }}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={true}
        width={1920}
        height={120}
        fDirection={"row"}
        color={colors.all.white}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <KhatabaIcon />
        <HeaderMenu />
        <UserName />
      </ET3Div>
      {isAlert ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={1920}
          height={50}
          fDirection={"row"}
          color={colors.all.red}
          style={{}}
          alignItems="center"
          justifyContent="center"
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={24}
            text={i18n.get("ALERT")}
            isSpan={false}
            color={colors.all.white}
            style={{}}
          />
        </ET3Div>
      ) : null}
    </header>
  );
});
export default Header;
